import { LegalLayout } from "./LegalLayout";
import { OPERATOR } from "../../../shared/constants";

// プライバシーポリシー(スキャフォールドの雛形。正式版は運営で確定)。
export function PrivacyPage() {
  return (
    <LegalLayout title="プライバシーポリシー">
      <p className="muted">
        {OPERATOR.companyName}（以下「当社」）は、{OPERATOR.serviceName}
        における個人情報の取扱いについて、以下のとおり定めます。
      </p>
      <h2>1. 取得する情報</h2>
      <p>
        メールアドレス、担当者名、電話番号、事務所情報、アップロードされた写真・素材等を取得します。
        また、公開サイトのAIチャットボット利用時に、不正利用防止のため訪問者のIPアドレスと会話ログを取得します。
      </p>
      <h2>2. 利用目的</h2>
      <p>本サービスの提供、サイト制作、お問い合わせ対応、料金請求のために利用します。</p>
      <h2>3. 第三者提供</h2>
      <p>
        法令に基づく場合を除き、ご本人の同意なく第三者に提供しません。サイト制作・AI機能の提供のため、
        必要な範囲で外部サービス（クラウド・AI事業者等）を利用します。
      </p>
      <h2>4. 安全管理</h2>
      <p>取得した情報は暗号化等の適切な手段で管理します。</p>
      <h2>5. 開示・訂正・削除</h2>
      <p>ご本人からの請求に応じ、法令に従って開示・訂正・削除に対応します。</p>
      <h2>6. お問い合わせ</h2>
      <p>本ポリシーに関するお問い合わせは当社までご連絡ください。</p>
      <p className="muted small">※ 本文はスキャフォールドの雛形です。</p>
    </LegalLayout>
  );
}
